import styled from 'styled-components';
import { DoubleArrow, UpArrow, DownArrow } from 'ui/icons';
import { button, spacing, colors } from 'ui/theme';
import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import { useQueryContext } from 'modules/savedViewsIndex/context';

type ButtonProps = {
  isActive: boolean;
};

export const Button = styled.button`
  ${button}
  align-items: center;
  background: none;
  border: none;
  color: ${(props: ButtonProps) => (props.isActive ? colors.purple100 : 'inherit')};
  cursor: 'pointer';
  display: flex;
  padding: ${spacing.half} 0;
  span {
    display: inline-block;
    margin-right: ${spacing.quarter};
  }
`;

export type Props = {
  column: { label: string; value: string };
};

export const HeaderCell = ({ column }: Props) => {
  const { sortBy, setSortBy, sortDirection, setSortDirection } = useQueryContext();
  const { label, value } = column;
  const isActive = sortBy === value;
  const isAscending = sortDirection === SORT_DIRECTIONS.ASCENDING;
  const color = isActive ? colors.purple100 : colors.grey50;

  const handleClick = () => {
    if (value === sortBy) {
      const direction =
        sortDirection === SORT_DIRECTIONS.ASCENDING
          ? SORT_DIRECTIONS.DESCENDING
          : SORT_DIRECTIONS.ASCENDING;
      setSortDirection(direction);
    } else {
      setSortBy(value);
      setSortDirection(SORT_DIRECTIONS.ASCENDING);
    }
  };

  return (
    <Button data-test="header-cell" isActive={isActive} onClick={() => handleClick()}>
      <span>{label}</span>
      {!isActive && <DoubleArrow color={color} />}
      {isActive && isAscending && <UpArrow color={color} />}
      {isActive && !isAscending && <DownArrow color={color} />}
    </Button>
  );
};
